import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { currentTenant } from './tenant/tenants';
import { applyTenantChrome } from './tenant/applyTenantChrome';

applyTenantChrome(currentTenant);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <App />
);
